import { Field, FieldWrapper } from "@progress/kendo-react-form";
import { useEffect } from "react";
import EventFieldService from "../../../services/srv-event/EventFieldService";
import CommonInput from "../../../components/sys-common/CommonInput";

export const EventFormAdditionalInfo = ({
  formRenderProps,
  additionalFields,
  setAdditionalFields,
}) => {
  useEffect(() => {
    getFields();
  }, [formRenderProps.valueGetter("etkinliK_TIPI_KODU")]);

  function getFields() {
    var etkinlikTipi = formRenderProps.valueGetter("etkinliK_TIPI_KODU");
    if (etkinlikTipi) {
      EventFieldService.getEventFields(etkinlikTipi).then((data) => {
        setAdditionalFields(data);
      });
    }
  }

  return (
    <div>
      {additionalFields.map((item) => (
        <FieldWrapper>
          <div className="k-form-field-wrap">
            <Field
              name={item.alaN_KODU}
              component={CommonInput}
              id={item.alaN_KODU}
              label={item.alaN_KODU_CEVIRI}
              required={true}
            />
          </div>
        </FieldWrapper>
      ))}
    </div>
  );
};
